// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html .cog-cognito--styled .cog-save-resume__button,:root:root:root:root:root .cog-cognito--styled .cog-save-resume__button{margin-top:calc((var(--button-primary__font-size) - var(--input__font-size, 1em))*-0.5)}html.cog-iframe-embed .cog-save-resume-dialog .el-dialog,:root:root:root:root:root.cog-iframe-embed .cog-save-resume-dialog .el-dialog{position:absolute;bottom:0;left:0;right:0}", ""]);
// Exports
module.exports = exports;
